import React from "react";
// components
import PageTitle from "../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import Table from '../widgets/tables/Table';
import Loading from "../components/Loading";
import checkToken from "../services/checkToken";
import getOrdiniConfermati from "../services/getOrdiniConfermati";

const cookies = new Cookies();
let username = cookies.get('username', { path: '/' });
let token = cookies.get('token', { path: '/' });
export default class ConfermaOrdini extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: true
        };
    }

    async reload() {
        this.setState({ isLoading: true });

        username = cookies.get('username', { path: '/' });
        token = cookies.get('token', { path: '/' });

        const check = await checkToken(username, token, true);
        const userType = parseInt(check.utente.tipo);

        let ordini = await getOrdiniConfermati(username, token);
        
        this.setState({ isLoading: false, ordini,  isUserType: userType });   
    }


    async componentDidMount() {
        await this.reload();
    }


    render() {

        if (this.state.isLoading)
            return <Loading />;

        const cookies = new Cookies();

        var headCells = [
            { id: 'rif', numeric: false, disablePadding: true, label: 'Rif' },
            { id: 'ragione_sociale', numeric: true, disablePadding: false, label: 'Cliente' },
            { id: 'data_creazione', numeric: true, disablePadding: false, label: 'Data Creazione' },
        ];

        this.searchCols = ['rif', 'ragione_sociale', 'data_creazione'];

        if ((this.state.isUserType === 0 || this.state.isUserType === 4) && headCells.find(h => h.id === 'icon') === undefined) {
            headCells.unshift({ id: 'icon', disablePadding: false, label: '', icon: true });
        }

        if (headCells.find(h => h.id === '_') === undefined) {
            headCells.push({ id: '_', numeric: true, disablePadding: false, label: '' });
        }

        return (
            <div id={Math.random()}>
                {
                    (this.state.isUserType !== 3) && <PageTitle title="Conferma Ordini" />
                }

                <Table headCells={headCells} searchCols={this.searchCols} rows={this.state.ordini} order={'desc'} sortBy={this.state.isUserType === 0 ? 1 : 0}
                    onEventClick={(row) => {
                        let found = this.state.ordini.find((element) => { 
                            return element.id === row;
                        });
                        window.open(found.link_conferma, '_blank');
                    }}
                />
            </div>
        );
    }
}

